"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var aboutContents = document.querySelectorAll('.about-content');
var aboutSliders = document.querySelectorAll('.about-slider');
var current = 0;
var setClass = function (index) {
    aboutContents.forEach(function (content, idx0) {
        if (index === idx0)
            return (content.className = 'about-content active');
        if (index - 1 === idx0)
            return (content.className = 'about-content prev');
        if (index + 1 === idx0)
            return (content.className = 'about-content next');
        if (index === aboutContents.length - 1 && idx0 === 0)
            return (content.className = 'about-content next');
        return (content.className = 'about-content');
    });
    aboutSliders.forEach(function (content, idx0) {
        if (index === idx0)
            return (content.className = 'about-slider active');
        if (index - 1 === idx0)
            return (content.className = 'about-slider prev');
        if (index + 1 === idx0)
            return (content.className = 'about-slider next');
        if (index === aboutContents.length - 1 && idx0 === 0)
            return (content.className = 'about-slider next');
        return (content.className = 'about-slider');
    });
};
document.addEventListener('DOMContentLoaded', function () {
    setClass(current);
    setTimeout(function () {
        setInterval(function () {
            current += 1;
            if (current >= aboutSliders.length)
                current = 0;
            setClass(current);
        }, 7500);
    }, 3000);
}, false);
